import axios from 'axios';
import Cookie from 'js-cookie';
import { getLoginPath, PASSPORT_URL } from '@/utils/uri';
import { isNuc } from '@/utils/env';
import { isNf1 } from '@/utils/project';
import router from '@/router';
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { createVNode } from 'vue';
import { useHeader } from '@/components/hooks/useHeader.js';

export const http = axios.create({
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  },
  withCredentials: true
});

export const isInHospEnv =
  typeof window.LOGIN_ENV !== 'undefined' && window.LOGIN_ENV
    ? window.LOGIN_ENV === 'uncloud'
    : process.env.VUE_APP_LOGIN_ENV &&
      process.env.VUE_APP_LOGIN_ENV === 'uncloud';
console.log('process.env=', process.env);
/**
 * 同步cookie令牌
 * apiToken和user_ticket保持一致
 * 从其他系统登录会导致令牌缺失
 */
export const syncCookieToken = () => {
  if (isInHospEnv) {
    const apiToken = isNuc ? Cookie.get('auth_token') : Cookie.get('apiToken');
    const userTicket = Cookie.get('user_ticket');
    const token = apiToken || userTicket;
    if (token && (!apiToken || !userTicket)) {
      Cookie.set('user_ticket', token, { expires: 1 });
      Cookie.set(isNuc ? 'auth_token' : 'apiToken', token, { expires: 1 });
    }
  }
};
const handleRelogin = (ishosp, cb) => {
  if (ishosp) {
    if (isNuc) {
      if (window.$handleLogin) {
        window.$handleLogin(true);
      } else {
        message.error('服务异常, 请稍后重试');
      }
    } else {
      // http://cooder.linkdoc.com:9999/fe/login-fe
      if (window._lkLoginJS) {
        window._lkLoginJS();
      } else {
        message.error('服务异常, 请稍后重试');
      }
    }
  } else {
    cb();
  }
};
function setRequestHeader(config) {
  if (isInHospEnv) {
    const token = isNuc ? Cookie.get('auth_token') : Cookie.get('apiToken');
    if (token) {
      config.headers.common.Authorization = 'Bearer ' + token;
    }
  }
}

const { logout } = useHeader();

//协议更新弹框通知后台同意或不同意接口
const signAgreement = params => {
  return http.post('/api/sys/agreement/isAgree', params);
};

let isAlertAgreementModal = false;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function injectLoginRequired(cb, loginFailed) {
  function getRes(obj) {
    const res = obj.response;
    if (res) {
      return res;
    } else {
      return obj;
    }
  }

  // http
  http.interceptors.request.use(config => {
    setRequestHeader(config);

    if (config.method.toLowerCase === 'post') {
      config.data = config.data;
    }

    config.data = {
      ...config.data
    };

    return config;
  });

  http.interceptors.response.use(
    resp => {
      // console.log('%c [ ok ]-127', 'font-size:12px; background:#1890ff; color:#fff;');
      const { status, data } = getRes(resp);
      // todo login.js
      if (status === 401) {
        const _loginFailed = () => {
          location.href = getLoginPath();
        };
        handleRelogin(isInHospEnv, _loginFailed);
      }

      if (isInHospEnv) {
        if (status === 200) {
          return resp;
        }
      }

      if (
        status === 200 &&
        (data.success === true ||
          data.status === 'success' ||
          (data && data.code === 200))
      ) {
        return resp;
      }

      let isShowNormalError = true;
      const hideNormalError = () => (isShowNormalError = false);

      setTimeout(() => {
        if (isShowNormalError) {
          cb(data);
        }
      });

      return Promise.reject({ data, hideNormalError });
    },
    error => {
      let isShowNormalError = true;
      const { status, data } = error.response;
      // console.log('%c [ err ]-127', 'font-size:12px; background:#1890ff; color:#fff;', status);
      // todo login.js

      //协议更新提示
      if (data.code === 'A0202') {
        if (!isAlertAgreementModal) {
          isAlertAgreementModal = true;
          Modal.confirm({
            title: '用户服务协议和隐私协议更新提示',
            icon: createVNode(ExclamationCircleOutlined),
            width: 438,
            content: createVNode('p', {}, [
              '感谢您使用科研平台的产品以及服务。我们根据最新的法律法规以及监管政策要求，更新了',
              createVNode(
                'a',
                {
                  href: `${location.origin}/service/agreement`,
                  target: '_blank'
                },
                '《科研平台用户服务协议》'
              ),
              '以及',
              createVNode(
                'a',
                {
                  href: `${location.origin}/privacy/policy`,
                  target: '_blank'
                },
                '《隐私协议》'
              ),
              '，特向您推送本提示。科研平台会根据具体的功能需要，收集必要的用户信息;未经过您的同意，科研平台不会自第三方获取、共享或对外提供您的个人信息。请您仔细阅读并充分理解相关条款。'
            ]),
            okText: '同意并继续',
            cancelText: '暂不使用',
            onOk: () => {
              signAgreement({ isAgree: true }).then(res => {
                if (res?.data?.success) {
                  isAlertAgreementModal = false;
                  location.reload();
                }
              });
            },
            onCancel: () => {
              signAgreement({ isAgree: false }).then(res => {
                if (res?.data?.success) {
                  isAlertAgreementModal = false;
                  logout();
                }
              });
            }
          });
        }
      }
      if (status === 401 || (data && Number(data.code) === 401)) {
        const _loginFailed = () => {
          location.href = getLoginPath();
        };
        handleRelogin(isInHospEnv, _loginFailed);
      }
      if (status === 403 || (data && Number(data.code) === 403)) {
        router.replace('/error/403');
      }
      if (status === 404 || (data && Number(data.code) === 404)) {
        router.replace('/error/404');
      }
      const hideNormalError = () => (isShowNormalError = false);

      setTimeout(() => {
        if (isShowNormalError) {
          cb(error);
        }
      });

      return Promise.reject({ error, hideNormalError });
    }
  );
}

/**
 * use as below:
 * export function getItems() {
 *   return delay(() => ({data: {}}));
 * }
 */
export function delayIt(fn, { delay = 100 } = {}) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(fn());
      } catch (ex) {
        reject(ex);
      }
    }, delay);
  });
}

export function isProd() {
  return process.env.NODE_ENV === 'production' || true;
}

/* service mock */
class Mock {
  static get() {
    return '';
  }
}

if (process.env.NODE_ENV !== 'production') {
  Mock.KEY = 'useMock';
  Mock.get = function() {
    return Cookie.get(Mock.KEY);
  };

  Mock.set = function(type) {
    if (type !== 'real-api') {
      Cookie.set(Mock.KEY, type, { path: '/' });
    } else {
      Cookie.remove(Mock.KEY, { path: '/' });
    }

    window.location.reload();
  };
}

const useMock = Mock.get;
const useMockType = () => {
  const type = Mock.get();
  if (type === 'local-mock') {
    return 'local';
  } else if (type === 'feonline-mock') {
    return 'api.fe';
  }
};

const injectLoginScriptForHospEnv = () => {
  // 私有化部署
  // if (process.env.NODE_ENV === 'production') {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = isNuc ? `${PASSPORT_URL}/passport.union.js` : '/js/login.js';
  document.body.appendChild(script);
  // }
};

const getAgreementConfig = () => {
  if (isNf1()) {
    return {
      text: '同意agreement和agreement\nI agree to agreement and agreement',
      configList: [
        { title: '科研平台用户服务协议', url: `${location.origin}/service/agreement` },
        { title: '隐私政策', url: `${location.origin}/privacy/policy` },
        { title: 'User Service Agreement', url: `${location.origin}/service/agreement` },
        { title: 'Privacy Policy', url: `${location.origin}/privacy/policy` }
      ]
    };
  }

  return {
    text: '同意agreement和agreement',
    configList: [
      { title: '科研平台用户服务协议', url: `${location.origin}/service/agreement` },
      { title: '隐私政策', url: `${location.origin}/privacy/policy` }
    ]
  };
};

export function installPassport(options = {}) {
  const loginScript = document.getElementById('_login_script');
  if (loginScript) {
    document.body.removeChild(loginScript);
  }

  // 判断登录方式配置：优先使用传入的参数，否则根据项目类型自动判断
  let loginTypes = options.loginTypes;

  if (!loginTypes || loginTypes.length === 0) {
    // 测试：NF1 项目使用自定义登录方式
    if (isNf1()) {
      loginTypes = ['email-agreement', 'sms-agreement', 'qr'];
    }
  }

  // 如果有登录方式配置，插入配置按钮
  if (loginTypes && loginTypes.length > 0) {
    const passportLoginElement = document.getElementById('passport-login');
    if (passportLoginElement) {
      passportLoginElement.parentNode.removeChild(passportLoginElement);
    }
    const div = document.createElement('div');
    document.body.appendChild(div);
    const config = {
      loginTypes: loginTypes,
      parentClass: 'embed-passport-login',
      agreementConfig: getAgreementConfig()
    };
    // NF1 项目使用双语模式（测试阶段：非 NF1 项目使用双语，待 NF1 域名申请下来后改回 isNf1()）
    const langAttr = isNf1() ? 'data-lang="bilingual"' : '';
    div.innerHTML = `<button style="position: fixed; left: -1000px; opacity: 0" data-client="linkhub" data-callback="getActuralUrl" id="passport-login" ${langAttr} data-config='${JSON.stringify(config)}'></button>`;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  // script.src = 'http://localhost:8113/static/fe/passport/app.js'; //开发环境地址
  script.src = `${PASSPORT_URL}/assets/dist/static/fe/passport/app.js`; //生产地址
  // script.src =
  //   'https://uc.bd.linkdoc.com/assets/dist/static/fe/passport/app.js'; //测试环境地址
  script.id = '_login_script';
  document.body.appendChild(script);
}

export function installPassportNotInLoginPage(id = 'app') {
  if (isInHospEnv) {
    injectLoginScriptForHospEnv();
  } else {
    // 云端-仅限于登录后的页面 用来超时弹窗，不能用于登录页，因为登录页面需要控制样式，配置属性data-config中的 parentClass
    // 首先判断passport-login是否存在，存在的话将其删除，防止同时存在id相同的dom元素
    const passportLoginElement = document.getElementById('passport-login');
    if (passportLoginElement) {
      passportLoginElement.parentNode.removeChild(passportLoginElement);
    }
    const app = document.getElementById(id);
    const div = document.createElement('div');
    app?.parentNode?.insertBefore(div, app);

    // 根据项目类型决定 loginTypes，与 installPassport 保持一致
    let loginTypes;
    if (location.host.indexOf('nuwarwe.net') > -1) {
      // 女娲环境
      loginTypes = ['sms-agreement'];
    } else if (isNf1()) {
      //  NF1 项目：包含带协议邮箱、带协议短信、扫码
      loginTypes = ['email-agreement', 'sms-agreement', 'qr'];
    } else {
      // 非NF1 项目
      loginTypes = ['sms', 'qr'];
    }

    const config = {
      loginTypes: loginTypes,
      agreementConfig: getAgreementConfig()
    };
    const langAttr = isNf1() ? 'data-lang="bilingual"' : '';
    div.innerHTML = `<button style="position: fixed; left: -1000px; opacity: 0" data-client="linkhub" data-callback="window.passportLoginCallback" id="passport-login" ${langAttr} data-config='${JSON.stringify(config)}'></button>`;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    // script.src = 'http://localhost:8113/static/fe/passport/app.js'; //开发环境地址
    script.src = `${PASSPORT_URL}/assets/dist/static/fe/passport/app.js`; //生产地址
    // script.src =
    //   'https://uc.bd.linkdoc.com/assets/dist/static/fe/passport/app.js'; //测试环境地址
    document.body.appendChild(script);
  }
}

export { Mock, useMock, useMockType };
